import { render } from "./QuotesDetail.vue?vue&type=template&id=28b47f29&ts=true"
import script from "./QuotesDetail.vue?vue&type=script&lang=ts"
export * from "./QuotesDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__